import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import '@/styles/index.scss'
import './components/common/directives';
import 'babel-polyfill';
import './util/rem'
import {post,get,del,put} from './utils/http'; 
import api from './utils/api';
import store from './store'
import core from './utils/core.js'
import echarts from 'echarts'
import config from '@/config'
import './assets/icon/iconfont.css';//iconfont样式
import preventReClick from './store/preventReClick' //防多次点击，重复提交
Vue.prototype.$echarts = echarts

Vue.prototype.api = api;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$del = del;
Vue.prototype.$put = put;
Vue.prototype.core = core
Vue.prototype.$config = config

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ElementUI);
const i18n = new VueI18n({
    locale: config.locale,
    messages
});

Vue.prototype.NumberMul = function(arg1, arg2) {
    var m = 0;
    var s1 = arg1.toString();
    var s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length;
    } catch (e) {}
    try {
        m += s2.split(".")[1].length;
    } catch (e) {}
 
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = config.title;
    const role = sessionStorage.getItem('kd_client_username');
    if (!role && to.path !== '/login' && to.path !== '/clientLogin') {
        next('/clientLogin')
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403');
    } else if(role && to.path == '/clientLogin') {
        next('/dashboard')
    } else {
        // 简单的判断IE10及以下不进入富文本编000000000000辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }   
});

router.afterEach((to,from,next)=>{
    window.scrollTo(0,0)
})

new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app');
